import { Component } from '@angular/core';

@Component({
  selector: 'app-item-skill',
  template: ``,
  styleUrls: []
})
export class ItemSkillComponent {

}
